<template>
  <div class="card mt-4">
    <h5 class="card-header">{{ title }}</h5>
    <div class="card-body">
      <ul class="list-group">
        <li v-for="file in files" :key="file.id" class="list-group-item d-flex justify-content-between align-items-center">
          <p class="card-text d-inline mb-0">
            {{ getFileName(file) }}
            <span v-if="getFileMetadata(file)">
              ({{ formatFileSize(getFileMetadata(file).size) }}, modified: {{ formatDate(getFileMetadata(file).modified_time) }})
            </span>
          </p>
          <div>
            <button type="button" @click="viewFile(file)" class="btn btn-primary btn-sm mx-1">View</button>
            <button type="button" @click="downloadFile(file)" class="btn btn-success btn-sm mx-1">Download</button>
            <button v-if="onEditFile" type="button" @click="editFile(file)" class="btn btn-secondary btn-sm mx-1">Edit</button>
            <button v-if="onDeleteFile" type="button" @click="deleteFile(file)" class="btn btn-danger btn-sm mx-1">Delete</button>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Subtask from '@/models/subtask';

export default {
  name: 'FilesListForm',
  props: {
    title: {
      type: String,
      required: true,
    },
    files: {
      type: Array,
      required: true,
    },
    filesMetadata: {
      type: Array,
      required: false,
    },
    onViewFile: {
      type: Function,
      required: true,
    },
    onDownloadFile: {
      type: Function,
      required: true,
    },
    onDeleteFile: {
      type: Function,
      required: false,
    },
    onEditFile: {
      type: Function,
      required: false,
    },
  },
  methods: {
    getFileName(filePath) {
      return filePath.split('/').pop();
    },
    getFileMetadata(file) {
      var result = null;
      if (this.filesMetadata && this.filesMetadata.length > 0) {
        result = this.filesMetadata.find(meta => meta.file_path === file);
      }
      return result;
    },
    viewFile(file) {
      this.onViewFile(file);
    },
    downloadFile(file) {
      this.onDownloadFile(file);
    },
    deleteFile(file) {
      this.onDeleteFile(file);
    },
    editFile(file) {
      this.onEditFile(file);
    },
    formatDate(date) {
      return Subtask.formatDateTimeZone(date);
    },
    formatFileSize(size) {
      return Subtask.formatFileSize(size);
    },
  },
};
</script>